module.exports = __webpack_public_path__ + "img/sdk-time-icon.2823198.svg";